"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var domainChoices = _ref.domainChoices,
      chosenDomain = _ref.chosenDomain,
      onChooseDomain = _ref.onChooseDomain,
      onChangeForm = _ref.onChangeForm,
      formsConfig = _ref.formsConfig;
  return _react2.default.createElement(
    "div",
    { id: "fc-checkout-domain-choices" },
    domainChoices.map(function (suggestion) {
      return _react2.default.createElement(
        "button",
        { onClick: function onClick() {
            return onChooseDomain(suggestion.DomainName);
          }, style: { border: chosenDomain === suggestion.DomainName ? "solid medium #C24242" : "none" } },
        _react2.default.createElement(
          "div",
          null,
          "\u2714"
        ),
        _react2.default.createElement(
          "div",
          null,
          suggestion.DomainName
        )
      );
    }),
    _react2.default.createElement(
      "div",
      { id: "fc-checkout-domain-actions" },
      _react2.default.createElement(
        "button",
        { onClick: function onClick() {
            return onChangeForm('domainChoicesForm', 'existingDomainForm', formsConfig.existingDomainForm);
          } },
        "I already have a domain"
      )
    )
  );
};